import React from "react";
import artists from "../../../../public/locals/artists.json";

export default ({ disabled, user, userType }) =>
  userType === "artist" ? (
    <div className="form-row">
      <div className="col-100 col-md-25 d-flex align-items-center">
        <label className="m-0">Artist Types</label>
      </div>
      <div className="col-100 col-md-75">
        <div className="select">
          <select
            defaultValue={user.artist_profile && user.artist_profile.artist_type}
            disabled={disabled}
            className="form-control"
            name="artist_profile_attributes[artist_type]"
          >
            <option value="" selected disabled>
              Artist type
            </option>
            {Object.keys(artists["types"]).map((k) => {
              return <option key={k}>{k}</option>;
            })}
          </select>
        </div>
      </div>
    </div>
  ) : null;
